import clsx from "clsx";
import React, { FC, HTMLAttributes, ReactNode } from "react";

interface FormFieldWrapperProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  className?: string;
  title?: string;
}

const FormFieldWrapper: FC<FormFieldWrapperProps> = ({
  children,
  className = "",
  title,
  ...rest
}) => {
  return (
    <div
      className={clsx(
        "bg-secondary-background w-full p-[22px] border rounded-[20px] flex flex-col gap-5",
        className,
      )}
      {...rest}
    >
      {!!title && <h5>{title}</h5>}
      {children}
    </div>
  );
};

export default FormFieldWrapper;
